module.exports = __webpack_public_path__ + "34736292/img/lock-icon.bb9c7166.svg";